import { Document } from '@react-pdf/renderer';
import FilmRenderComponent from './FilmRenderComponent';
import { observer } from 'mobx-react-lite';
import { FilmData } from '../../../app/stores/FilmAnaysisAndRepairReport/types';

interface Props {
  totalPageCount: number;
  pageNumber: number;
  GroupData: FilmData[];
}

const FilmAnalysis: React.FC<Props> = ({
  totalPageCount,
  pageNumber,
  GroupData,
}) => {
  const totalPages = totalPageCount || 10;
  return (
    <Document>
      {Array.from({ length: totalPages }, (_, index) => (
        <FilmRenderComponent
          key={index}
          pageNumber={index * 8}
          totalPageCount={totalPages}
          GroupData={[GroupData[index]]}
        />
      ))}
    </Document>
  );
};

export default observer(FilmAnalysis);
